<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1l2kge/tc-custom/9781446359518.jpg?1740284537121" alt="This image is the cover for the book Stitch, Craft, Create: Cake Decorating"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stitch, Craft, Create: Cake Decorating
      </h1>
      <p class="bookDescription body article font2">
        <p>Want to try your hand at making gorgeous homemade goodies? These brilliant quick &amp; easy cake decorating projects give you the opportunity to try something new and expand your crafting skills! From beautiful biscuits to floral cupcakes, festive treats to celebratory cakes designs, create stunning items for yourself, your friends and your home.</p><p>Each unique project includes:</p>Simple step-by-step instructionsQuick makes for fast resultsBeautiful photography of the finished product to guide and inspire
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Various
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?423837cc